<template>
  <div class="availability-list-item availability-grid">
    <div class="availability-grid__address address">
      <div
        v-if="info.metro.length"
        class="metro"
      >
        <div
          v-for="metro in info.metro"
          :key="metro.id"
        >
          <span :style="{backgroundColor: metro.line.color}" />{{ metro.name }}
        </div>
      </div>

      <span>{{ info.address }}</span>

      <div
        v-if="isNeedPrepay || isNeedQrCode"
        class="availability-list-item__markers"
      >
        <tag
          v-if="isNeedPrepay"
          title="100%&nbsp;&nbsp;предоплата"
          width="120px"
          color="#ffb71b"
          class="availability-list-item__marker"
        />
        <tag
          v-if="isNeedQrCode"
          title="Вход по QR"
          width="80px"
          color="#c1e0e0"
          class="availability-list-item__marker"
        />
      </div>
    </div>

    <div class="availability-list-item__info availability-grid__delay">
      <span class="availability-list-item__info-title">Наличие:</span>
      <span class="availability-list-item__info-value">{{ delayTitle }}</span>
    </div>

    <div class="availability-list-item__info date availability-grid__can-pickup">
      <span class="availability-list-item__info-title">Можно забрать:</span>
      <span class="availability-list-item__info-value blue">{{ closestDate }}</span>
    </div>

    <to-cart
      :product="PRODUCT"
      :sku-id="ACTIVE_SKU.id"
      hide-icons
      hide-notification
      :store-id="info.id"
      text-add="Забрать из магазина"
      class="availability-list-item__pickup-button availability-grid__end"
      @add="$emit('add-to-cart', info.id)"
    />
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import clearTimeFromDate from '@/utils/clear-time-from-date';
import ToCart from './to-cart';
import Tag from '@kit/tag/tag.vue';
import { ddmmyyyy } from '@/utils/date-to-string';

export default {
  name: 'availability-list-item',

  components: {
    Tag,
    ToCart
  },

  props: {
    info: {
      type: Object,
      required: true,
    }
  },

  computed: {
    ...mapGetters({
      PRODUCT: 'product/item',
      ACTIVE_SKU: 'product/activeSku',
    }),

    delivery() {
      return this.info.availableSkus.find(sku => sku.id === this.ACTIVE_SKU.id)?.delivery;
    },

    closestDate() { // при delayed = false, nearestDate не приходит, поэтому "сегодня" ставим вручную
      let delayedDays = this.delivery?.nearestDate ?
          (clearTimeFromDate(new Date(this.delivery.nearestDate)).setHours(0) - clearTimeFromDate(new Date()).setHours(0)) / 86400000
          : 0;

      if (!this.delivery?.delayed) {
        return 'Сегодня'
      } else if (delayedDays === 1) {
        return 'Завтра'
      } else {
        return this.delivery?.nearestDate
          ? ddmmyyyy(new Date(this.delivery.nearestDate))
          : '';
      }
    },
    delayTitle() {
      return this.delivery?.delayed ?  'Под заказ' : 'В наличии';
    },

    isNeedPrepay() {
      const { delivery } = this.info.availableSkus.find(sku => sku.id === this.ACTIVE_SKU.id) || {};
      return !!delivery?.needPrepay;
    },

    isNeedQrCode() {
      const { workMode } = this.info;
      return !!(workMode && workMode.toLowerCase() !== 'магазин');
    },
  },
};
</script>

<style lang="scss">
@import "./availability-grid.scss";

.availability-list-item {
  flex-direction: column;
  align-items: flex-start;
  padding: 16px 12px 20px;
  font-size: 12px;
  line-height: 20px;
  border-bottom: 1px solid $gray_lu;

  & > .address {
    margin-bottom: 4px;

    .metro {
      display: flex;
      flex-wrap: wrap;
    }

    .metro > div {
      display: flex;
      align-items: center;
      margin-right: 12px;
      white-space: nowrap;

      & > span {
        display: block;
        width: 8px;
        height: 8px;
        margin-right: 8px;
        border-radius: 50%;
      }
    }

    & > span {
      display: block;
      margin-top: 4px;
      font-size: 14px;
      font-weight: 600;
    }
  }

  &__pickup-button {
    width: 100%;
    margin-top: 4px;
  }

  &__info {
    font-size: 12px;
    line-height: 20px;
    margin-bottom: 4px;
  }

  &__info-title {
    color: $gray;
  }

  &__info-value {
    color: $black;
    margin-left: 4px;

    &.blue {
      color: $blue;
    }
  }

  &__markers {
    display: flex;
    flex-wrap: wrap;
  }

  &__marker {
    margin: 4px 4px 0 0;
  }
}

@include breakpoint("tablet") {
  .availability-list-item {
    padding: 12px;

    & > .address {
      margin: 0;
    }

    &__pickup-button {
      margin-top: 0;
      margin-left: 16px;
      white-space: nowrap;

      .to-cart__button {
        padding: 8px 12px;
      }
    }

    &__info {
      margin-bottom: 0;
    }

    &__info-title {
      display: none;
    }
  }
}

@include breakpoint("desktop") {
  .availability-list-item {
    padding: 20px;
    font-size: 14px;
    line-height: 24px;

    & > .address {

      & > span {
        font-size: 16px;
      }
    }

    &__info {
      font-size: 14px;
      line-height: 24px;
    }

    &__pickup-button {
      min-width: 164px;
      height: 56px;

      .to-cart__button {
        padding: 16px;
      }
    }
  }
}
</style>
